import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export function scrollTo(targetObjOrSel, offset = 0) {
    // logic to get the target object
    let targetObject = targetObjOrSel;
    if (typeof targetObjOrSel === "string") {
        targetObject = document.querySelector(targetObjOrSel)
    }
    if (!targetObject) return false;

    // logic to update the URL with the hash without jumping to the anchor
    const anchorId = targetObject.id
    // temporarily remove the ID from the target element
    targetObject.setAttribute('id', '');
    // add the hash to the URL
    location.hash = anchorId
    // restore the ID to the target element
    targetObject.setAttribute('id', anchorId)

    // special logic for home
    if (document.body.classList.contains("home")) {
        offset = 0
    }

    // calculate the Y value
    const yVal = window.pageYOffset + targetObject.getBoundingClientRect().top - offset
    // scroll to the Y value with gsap
    gsap.to(window, { scrollTo: yVal })

    // success, return true so that the outer function can e.g. preventDefault
    return true;
}

export function AnchorScrollTo(offset = 0) {

    // register a global click listener
    document.addEventListener('click', function (e) {
        // listen only to anchor tags:
        // - <a href="#test" ...
        // - <a href="/#test" ...
        // - <a href="/de/#test" ...
        if (e.target.tagName === 'A') {
            // extract the href
            const href = e.target.getAttribute('href')
            // if only # -> nothing to see here
            if (href === "#") return
            // get the index of the hash char
            const indexOfHash = href.indexOf("#")
            // continue processing only if there is a hash char at all
            if (indexOfHash >= 0) {
                // get the hash selector (including the hash, e.g. #test-123)
                const targetSelector = href.slice(indexOfHash, href.length)
                // check that the same page is used in the link (e.g. we are on page /de/ and the hash is /de/#test-123)
                // or that the hash is completely local, e.g. #test-123
                if (indexOfHash === 0 || href.replace(targetSelector, "") === window.location.pathname) {
                    // scroll, respecting the offset
                    const scrollToSuccess = scrollTo(targetSelector, offset)
                    // no default behaviour
                    if (scrollToSuccess) e.preventDefault();
                }

            } else {
                // external link
            }
        }
    })

}